import { NotificationsTypes } from '@modules';

export type NotificationsStateType = {
  list: NotificationsTypes.NotificationType[];
};

export const initialState: NotificationsStateType = {
  list: [],
};

export default initialState;
